module.exports = require("./ru-KZ");